module.exports = __webpack_public_path__ + "img/2_50.7206d94a.png";